import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

/**
 * Visible breadcrumb trail (helps both users and Google show breadcrumb rich
 * results). Pairs with buildBreadcrumbSchema() for the matching JSON-LD.
 * items: [{ label, to }] — last item is treated as the current page.
 */
export const Breadcrumbs = ({ items = [], className = "" }) => {
  return (
    <Breadcrumb className={className} data-testid="breadcrumb-trail">
      <BreadcrumbList>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <span key={`${item.to}-${idx}`} className="inline-flex items-center gap-1.5 sm:gap-2.5">
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="text-white/90" data-testid="breadcrumb-current">
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={item.to} className="text-white/60 hover:text-[color:var(--gold-400)]" data-testid={`breadcrumb-link-${idx}`}>
                      {item.label}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator className="text-white/40" />}
            </span>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
